export const emptyList = [
  {
    mode: "home",
    main: "Empty library",
    sub: "Click the import button to add books",
  },
  {
    mode: "favorite",
    main: "No favorite books",
    sub: "Right click on any book and click Add to favorite to add it to your favorite books",
  },
  {
    mode: "bookmark",
    main: "Empty bookmark",
    sub: "Move your mouse on the top edge of the reader",
  },
  {
    mode: "note",
    main: "Empty note",
    sub: "Select any text and click the note button on the popup menu",
  },
  {
    mode: "digest",
    main: "Empty highlight",
    sub: "Select any text and click the highlight button on the popup menu",
  },
  {
    mode: "shelf",
    main: "Empty shelf",
    sub: "Move your mouse on top of any book, then click the more icon to add the book to the shelf",
  },

  {
    mode: "trash",
    main: "Empty recycle bin",
    sub: "The deleted books will show up here",
  },
];
